import { useCallback, useState } from "react";
import { EHttpCode, PAYMENT_AUTHENTICATION_REQUIRED } from "@constants";
import { IHpp, IHppResponse, mapHpp } from "@common/PaymentIframe";
import { useFetch } from "@common/hook/useFetch";
import { IError } from "itsf-ui-common";

interface IParams {
    amount?: number;
    payWithSavedCardApiRoute(cardId: string): string;
    successCallback(): void;
}

export const useSavedPaymentMethodCardList = (props: IParams) => {
    const { amount, payWithSavedCardApiRoute, successCallback } = props;
    const [payWithSavedCardFetchState, { post }] = useFetch();
    const [hpp, setHpp] = useState<IHpp>();
    const [errorToDisplay, setErrorToDisplay] = useState<IError>();

    const submitPayment = useCallback(
        (selectedPaymentMethodCard: string) => {
            setErrorToDisplay(undefined);

            post(payWithSavedCardApiRoute(selectedPaymentMethodCard), {
                body: { amount },
                forwardError: true,
            })
                .then(successCallback)
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                .catch((error) => {
                    if (
                        error.status === EHttpCode.BAD_REQUEST &&
                        error.errorCode === PAYMENT_AUTHENTICATION_REQUIRED &&
                        error.additionalParameters
                    ) {
                        setHpp(mapHpp(error.additionalParameters as IHppResponse));
                    } else {
                        setErrorToDisplay(error);
                    }
                });
        },
        [post, payWithSavedCardApiRoute, amount, successCallback]
    );

    return {
        hpp,
        isPaymentWithSavedCardLoading: payWithSavedCardFetchState.isLoading,
        submitPayment,
        errorToDisplay,
    };
};
